import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Fab from '@mui/material/Fab';
import RightIcon from '@mui/icons-material/KeyboardArrowRight';
import LeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useDispatch } from 'react-redux';
import { colorPalette } from '../../../../theme/palette';
import { openMenu, closeMenu } from '../../../../old/actions';

const useStyles = makeStyles(() => ({
  toggleCollapsed: {
    left: ({ collapsed }) => (collapsed ? '80px' : '242px'),
    backgroundColor: '#3777E7',
    color: '#fff',
    boxShadow: 'none',
    position: 'fixed',
    display: 'block',
    top: '45%',
    paddingTop: '2px',
    transition: 'all 250ms ease-in-out',
    '&:hover': {
      backgroundColor: colorPalette[1]
    },
    minHeight: '28px',
    height: '28px',
    width: '28px'
  }
}));

const ToggleButton = ({ menuOpen }) => {
  const classes = useStyles({ collapsed: !menuOpen });
  const dispatch = useDispatch();
  const toggleMenu = () => dispatch(menuOpen ? closeMenu() : openMenu());

  return (
    <Fab className={classes.toggleCollapsed} onClick={toggleMenu} aria-label="toggle" size="small">
      {menuOpen ? <LeftIcon /> : <RightIcon />}
    </Fab>
  );
};

ToggleButton.propTypes = {
  menuOpen: PropTypes.bool
};

export default ToggleButton;
